// #7296: `serializeCover` (used by the order path) expects the runtime cover shape,
// where the AI cover image lives under `coverUrl`. The cart holds a persisted (Stored)
// cover whose URL is under `aiGeneratedCoverUrl`; restore `coverUrl` before serializing,
// otherwise the AI cover URL is dropped from the order and its analytics.
export function toRuntimeCover<T extends object>(
  cover: T & { aiGeneratedCoverUrl?: string; coverUrl?: string }
): T {
  if (!cover?.aiGeneratedCoverUrl || cover.coverUrl) {
    return cover
  }
  return { ...cover, coverUrl: cover.aiGeneratedCoverUrl }
}
